/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#1A1A1A";
export const ColorTextPrimaryInverted = "#FFFFFF";
export const ColorTextSecondary = "rgba(13,15,19,0.76)";
export const ColorTextSecondaryInverted = "rgba(255,255,255,0.6)";
export const ColorTextBrand = "#002643";
export const ColorTextBrandInverted = "#FFFFFF";
export const ColorTextDisabled = "rgba(19,29,60,0.4)";
export const ColorTextDisabledInverted = "rgba(255,255,255,0.3)";
export const ColorTextInactive = "rgba(19,29,60,0.4)";
export const ColorTextActive = "#002643";
export const ColorTextLink = "#1A1A1A";
export const ColorTextLinkInverted = "#FFFFFF";
export const ColorTextLinkHover = "rgba(14,24,54,0.5)";
export const ColorTextLinkHoverInverted = "rgba(255,255,255,0.5)";
export const ColorTextSale = "#BD0229";
export const ColorTextSuccess = "#32852D";
export const ColorTextOnSuccessLight = "#275724";
export const ColorTextOnSuccess = "#FFFFFF";
export const ColorTextError = "#DA2828";
export const ColorTextOnErrorLight = "#981C1C";
export const ColorTextOnError = "#FFFFFF";
export const ColorTextWarning = "#AE600E";
export const ColorTextOnWarningLight = "#803A13";
export const ColorTextOnWarning = "#FFFFFF";
export const ColorTextInfo = "#6D6D6D";
export const ColorTextOnInfoLight = "#5D5D5D";
export const ColorTextOnInfo = "#FFFFFF";
export const ColorIconPrimary = "#1A1A1A";
export const ColorIconPrimaryInverted = "#FFFFFF";
export const ColorIconSecondary = "rgba(14,24,54,0.5)";
export const ColorIconSecondaryInverted = "rgba(255,255,255,0.5)";
export const ColorIconBrand = "#002643";
export const ColorIconBrandInverted = "#FFFFFF";
export const ColorIconDisabled = "rgba(33,47,87,0.3)";
export const ColorIconDisabledInverted = "rgba(255,255,255,0.3)";
export const ColorIconInactive = "rgba(0,0,0,0.4)";
export const ColorIconActive = "#002643";
export const ColorIconHover = "#1A1A1A";
export const ColorIconFocus = "#1A1A1A";
export const ColorIconSuccess = "#32852D";
export const ColorIconOnSuccessLight = "#275724";
export const ColorIconOnSuccess = "#FFFFFF";
export const ColorIconError = "#DA2828";
export const ColorIconOnErrorLight = "#981C1C";
export const ColorIconOnError = "#FFFFFF";
export const ColorIconWarning = "#AE600E";
export const ColorIconOnWarningLight = "#803A13";
export const ColorIconOnWarning = "#FFFFFF";
export const ColorIconInfo = "#878B99";
export const ColorIconOnInfoLight = "#676973";
export const ColorIconOnInfo = "#FFFFFF";
export const ColorIconFavorite = "#F90935";
export const ColorBackgroundPrimary = "#FFFFFF";
export const ColorBackgroundSecondary = "#F7F8FB";
export const ColorBackgroundTertiary = "#EBECF5";
export const ColorBackgroundBrand = "#002643";
export const ColorBackgroundOverlay = "rgba(0,0,0,0.3)";
export const ColorBackgroundInactive = "#FFFFFF";
export const ColorBackgroundActive = "rgba(60,75,119,0.04)";
export const ColorBackgroundHover = "rgba(52,77,152,0.1)";
export const ColorBackgroundFocus = "rgba(52,77,152,0.1)";
export const ColorBackgroundPressed = "rgba(60,77,129,0.2)";
export const ColorBackgroundDisabled = "rgba(0,38,67,0.1)";
export const ColorBackgroundSuccess = "#32852D";
export const ColorBackgroundSuccessLight = "#C9ECC6";
export const ColorBackgroundError = "#DA2828";
export const ColorBackgroundErrorLight = "#FDCBCB";
export const ColorBackgroundWarning = "#AE600E";
export const ColorBackgroundWarningLight = "#F7E090";
export const ColorBackgroundInfo = "#EBECF5";
export const ColorBackgroundInfoLight = "#EBECF5";
export const ColorBorderPrimary = "rgba(19,29,60,0.4)";
export const ColorBorderPrimaryInverted = "rgba(255,255,255,0.4)";
export const ColorBorderSecondary = "rgba(60,77,129,0.2)";
export const ColorBorderSecondaryInverted = "rgba(255,255,255,0.2)";
export const ColorBorderTertiary = "rgba(52,77,152,0.1)";
export const ColorBorderTertiaryInverted = "rgba(255,255,255,0.1)";
export const ColorBorderBrand = "#002643";
export const ColorBorderFocus = "#1A1A1A";
export const ColorBorderHover = "#1A1A1A";
export const ColorBorderDisabled = "rgba(52,77,152,0.1)";
export const ColorBorderFocusRing = "#1A1A1A";
export const ColorBorderFocusRingInverted = "#FFFFFF";
export const ColorBorderSuccess = "#32852D";
export const ColorBorderWarning = "#AE600E";
export const ColorBorderError = "#DA2828";
export const ColorBorderInfo = "#878B99";
export const OutlineWidth = "2px";
export const OutlineOffset = "2px";
export const Spacing2 = "2px";
export const Spacing4 = "4px";
export const Spacing6 = "6px";
export const Spacing8 = "8px";
export const Spacing12 = "12px";
export const Spacing16 = "16px";
export const Spacing20 = "20px";
export const Spacing24 = "24px";
export const Spacing28 = "28px";
export const Spacing32 = "32px";
export const Spacing40 = "40px";
export const Spacing48 = "48px";
export const Spacing56 = "56px";
export const Spacing64 = "64px";
export const Spacing72 = "72px";
export const Spacing80 = "80px";
export const Spacing88 = "88px";
export const Spacing96 = "96px";
export const Spacing104 = "104px";
export const Spacing112 = "112px";
export const Spacing120 = "120px";
export const TypographyFamilyPrimary =
  '"Inter", "Inter Fallback", "Inter Fallback Android"';
export const TypographyFamilySecondary = "DM_Serif_Text, serif";
export const TypographyHeadlineWeight = 400;
export const TypographyHeadlineSizeXxxl = "4rem";
export const TypographyHeadlineSizeXxl = "3.4285714285714284rem";
export const TypographyHeadlineSizeXl = "2.857142857142857rem";
export const TypographyHeadlineSizeLarge = "2.2857142857142856rem";
export const TypographyHeadlineSizeMedium = "2rem";
export const TypographyHeadlineSizeSmall = "1.7142857142857142rem";
export const TypographyHeadlineSizeXs = "1.4285714285714286rem";
export const TypographyHeadlineSizeXxs = "1.2857142857142858rem";
export const TypographyTitleWeight = 600;
export const TypographyTitleSizeXl = "1.7142857142857142rem";
export const TypographyTitleSizeLarge = "1.4285714285714286rem";
export const TypographyTitleSizeMedium = "1.2857142857142858rem";
export const TypographyTitleSizeSmall = "1.1428571428571428rem";
export const TypographyBodyWeightDefault = 400;
export const TypographyBodyWeightStrong = 600;
export const TypographyBodySizeLarge = "1.1428571428571428rem";
export const TypographyBodySizeMedium = "1rem";
export const TypographyBodySizeSmall = "0.8571428571428571rem";
export const TypographyLabelWeightDefault = 400;
export const TypographyLabelWeightStrong = 600;
export const TypographyLabelSizeLarge = "1.1428571428571428rem";
export const TypographyLabelSizeMedium = "1rem";
export const TypographyLabelSizeSmall = "0.8571428571428571rem";
export const TypographyLinkWeightDefault = 400;
export const TypographyLinkWeightStrong = 600;
export const TypographyLinkSizeLarge = "1.1428571428571428rem";
export const TypographyLinkSizeMedium = "1rem";
export const TypographyLinkSizeSmall = "0.8571428571428571rem";
export const RadiusSmall = "4px";
export const RadiusMedium = "8px";
export const RadiusLarge = "16px";
export const RadiusFull = "100vw";
export const ComponentsCtaRadiusSmall = "8px";
export const ComponentsCtaRadiusMedium = "8px";
export const ComponentsCtaRadiusLarge = "8px";
export const ComponentsCtaPrimaryTextDefault = "#FFFFFF";
export const ComponentsCtaPrimaryIconDefault = "#FFFFFF";
export const ComponentsCtaPrimaryBgDefault = "#002643";
export const ComponentsCtaPrimaryBgHover = "#335369";
export const ComponentsCtaPrimaryBgPressed = "#4D697B";
export const ComponentsCtaPrimaryBgFocused = "#335369";
export const ComponentsCtaPrimaryBorderDefault = "transparent";
export const ComponentsCtaPrimaryBorderHover = "transparent";
export const ComponentsCtaPrimaryBorderPressed = "transparent";
export const ComponentsCtaPrimaryBorderFocus = "transparent";
export const ComponentsCtaPrimaryInvertedTextDefault = "#0E2B5D";
export const ComponentsCtaPrimaryInvertedIconDefault = "#0E2B5D";
export const ComponentsCtaPrimaryInvertedBgDefault = "#FFFFFF";
export const ComponentsCtaPrimaryInvertedBgHover = "rgba(255,255,255,0.9)";
export const ComponentsCtaPrimaryInvertedBgPressed = "rgba(255,255,255,0.9)";
export const ComponentsCtaPrimaryInvertedBgFocused = "rgba(255,255,255,0.6)";
export const ComponentsCtaPrimaryInvertedBorderDefault = "transparent";
export const ComponentsCtaPrimaryInvertedBorderHover = "transparent";
export const ComponentsCtaPrimaryInvertedBorderPressed = "transparent";
export const ComponentsCtaPrimaryInvertedBorderFocus = "transparent";
export const ComponentsCtaSecondaryTextDefault = "#1A1A1A";
export const ComponentsCtaSecondaryIconDefault = "#1A1A1A";
export const ComponentsCtaSecondaryBgDefault = "rgba(0,38,67,0.1)";
export const ComponentsCtaSecondaryBgHover = "rgba(0,38,67,0.2)";
export const ComponentsCtaSecondaryBgPressed = "rgba(0,38,67,0.3)";
export const ComponentsCtaSecondaryBgFocused = "rgba(0,38,67,0.2)";
export const ComponentsCtaSecondaryBorderDefault = "transparent";
export const ComponentsCtaSecondaryBorderHover = "transparent";
export const ComponentsCtaSecondaryBorderPressed = "transparent";
export const ComponentsCtaSecondaryBorderFocus = "transparent";
export const ComponentsCtaSecondaryInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaSecondaryInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaSecondaryInvertedBgDefault = "rgba(255,255,255,0.2)";
export const ComponentsCtaSecondaryInvertedBgHover = "rgba(255,255,255,0.3)";
export const ComponentsCtaSecondaryInvertedBgPressed = "rgba(255,255,255,0.4)";
export const ComponentsCtaSecondaryInvertedBgFocused = "rgba(255,255,255,0.3)";
export const ComponentsCtaSecondaryInvertedBorderDefault = "transparent";
export const ComponentsCtaSecondaryInvertedBorderHover = "transparent";
export const ComponentsCtaSecondaryInvertedBorderPressed = "transparent";
export const ComponentsCtaSecondaryInvertedBorderFocus = "transparent";
export const ComponentsCtaTertiaryTextDefault = "#002643";
export const ComponentsCtaTertiaryIconDefault = "#002643";
export const ComponentsCtaTertiaryBgDefault = "transparent";
export const ComponentsCtaTertiaryBgHover = "rgba(0,38,67,0.1)";
export const ComponentsCtaTertiaryBgPressed = "rgba(0,38,67,0.2)";
export const ComponentsCtaTertiaryBgFocused = "rgba(0,38,67,0.1)";
export const ComponentsCtaTertiaryBorderDefault = "#002643";
export const ComponentsCtaTertiaryBorderHover = "#002643";
export const ComponentsCtaTertiaryBorderPressed = "#002643";
export const ComponentsCtaTertiaryBorderFocus = "#1A1A1A";
export const ComponentsCtaTertiaryInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBgDefault = "transparent";
export const ComponentsCtaTertiaryInvertedBgHover = "transparent";
export const ComponentsCtaTertiaryInvertedBgPressed = "transparent";
export const ComponentsCtaTertiaryInvertedBgFocused = "rgba(255,255,255,0.1)";
export const ComponentsCtaTertiaryInvertedBorderDefault =
  "rgba(255,255,255,0.3)";
export const ComponentsCtaTertiaryInvertedBorderHover = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderPressed = "#FFFFFF";
export const ComponentsCtaTertiaryInvertedBorderFocus = "#FFFFFF";
export const ComponentsCtaGhostTextDefault = "#1A1A1A";
export const ComponentsCtaGhostIconDefault = "#1A1A1A";
export const ComponentsCtaGhostBgDefault = "transparent";
export const ComponentsCtaGhostBgHover = "rgba(0,38,67,0.1)";
export const ComponentsCtaGhostBgPressed = "rgba(0,38,67,0.2)";
export const ComponentsCtaGhostBgFocused = "rgba(0,38,67,0.1)";
export const ComponentsCtaGhostBorderDefault = "transparent";
export const ComponentsCtaGhostBorderHover = "transparent";
export const ComponentsCtaGhostBorderPressed = "transparent";
export const ComponentsCtaGhostBorderFocus = "transparent";
export const ComponentsCtaGhostInvertedTextDefault = "#FFFFFF";
export const ComponentsCtaGhostInvertedIconDefault = "#FFFFFF";
export const ComponentsCtaGhostInvertedBgDefault = "transparent";
export const ComponentsCtaGhostInvertedBgHover = "rgba(255,255,255,0.1)";
export const ComponentsCtaGhostInvertedBgPressed = "rgba(255,255,255,0.2)";
export const ComponentsCtaGhostInvertedBgFocused = "rgba(255,255,255,0.1)";
export const ComponentsCtaGhostInvertedBorderDefault = "transparent";
export const ComponentsCtaGhostInvertedBorderHover = "transparent";
export const ComponentsCtaGhostInvertedBorderPressed = "transparent";
export const ComponentsCtaGhostInvertedBorderFocus = "transparent";
export const ComponentsCtaInlineText = "#1A1A1A";
export const ComponentsCtaInlineBg = "transparent";
export const ComponentsCtaInlineTextHover = "rgba(15,20,35,0.64)";
export const ComponentsCtaInlineTextFocus = "#1A1A1A";
export const ComponentsCtaInlineTextPressed = "rgba(4,4,5,0.81)";
export const ComponentsCtaInlineTextDisabled = "rgba(19,29,60,0.4)";
export const ComponentsCtaInlineBorderFocus = "#1A1A1A";
export const ComponentsCtaInlineSecondaryText = "rgba(13,15,19,0.76)";
export const ComponentsCtaInlineSecondaryBg = "transparent";
export const ComponentsCtaInlineSecondaryTextHover = "rgba(4,4,5,0.81)";
export const ComponentsCtaInlineSecondaryTextFocus = "rgba(0,0,0,0.8)";
export const ComponentsCtaInlineSecondaryTextPressed = "rgba(4,5,7,0.88)";
export const ComponentsCtaInlineSecondaryTextDisabled = "rgba(19,29,60,0.4)";
export const ComponentsCtaInlineSecondaryBorderFocus = "#1A1A1A";
export const ComponentsCtaInlineInvertedText = "#FFFFFF";
export const ComponentsCtaInlineInvertedBg = "transparent";
export const ComponentsCtaInlineInvertedTextHover = "rgba(255,255,255,0.5)";
export const ComponentsCtaInlineInvertedTextFocus = "rgba(255,255,255,0.5)";
export const ComponentsCtaInlineInvertedTextPressed = "rgba(255,255,255,0.8)";
export const ComponentsCtaInlineInvertedTextDisabled = "rgba(255,255,255,0.3)";
export const ComponentsCtaInlineInvertedBorderFocus = "#FFFFFF";
export const ComponentsCtaNavigationText = "#1A1A1A";
export const ComponentsCtaNavigationBg = "#FFFFFF";
export const ComponentsCtaNavigationBgHover = "#D8DBE5";
export const ComponentsCtaNavigationBgFocus = "#D8DBE5";
export const ComponentsCtaNavigationBgPressed = "#BCC0CC";
export const ComponentsCtaDisabledTextDisabled = "rgba(19,29,60,0.4)";
export const ComponentsCtaDisabledIconDisabled = "rgba(33,47,87,0.3)";
export const ComponentsCtaDisabledBgDisabled = "rgba(0,38,67,0.1)";
export const ComponentsCtaDisabledBorderDisabled = "transparent";
export const ComponentsRatingActive = "#1A1A1A";
export const ComponentsRatingInactive = "rgba(33,47,87,0.3)";
export const ComponentsRatingStroke = "#FFFFFF";
export const ComponentsHeaderHeight = "120px";
export const ComponentsHeaderHeightDesktop = "72px";
export const ComponentsMenuBg = "#EFEDEA";
export const ComponentsMenuText = "#000000";
export const ComponentsMenuHeadline = "#666666";
export const ComponentsMenuDivider = "#E8E3E0";
export const ComponentsProductCardOverlay = "rgba(60,75,119,0.04)";
export const ComponentsLabelFixedPriceText = "#1A1A1A";
export const ComponentsLabelFixedPriceTextInverted = "#C63B08";
export const ComponentsLabelFixedPriceBg = "#FF8326";
export const ComponentsLabelNewText = "#FFFFFF";
export const ComponentsLabelNewBg = "#1A1A1A";
export const AssetsFeaturedFooterMedicalPictogram =
  "/images/splashes/MedicalCross.svg";
export const AssetsStarIconUrl =
  "/images/icons/design-system/matas/24px/StarFilled.svg";
